import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react'; // Icons import kiye

const Hero = () => {
  const sliderImages = [
    "https://www.bigbasket.com/media/uploads/flatpages/mailer-images-aug/40322868-to-40322881_020125_w4.jpg",
    "https://m.media-amazon.com/images/I/61YrwoTCDlL.jpg",
    "https://encrypted-tbn1.gstatic.com/shopping?q=tbn:ANd9GcTqBz9isb8CwxEyYHaN8Ougf6zhrJSzH3n7iEX8txGWOc4--nE5VjrQtVW8SWFEtxlsWro4ZZsSLBCjbT3gkCXsqsJqFHB2-UREDC86yhMH",
    "https://encrypted-tbn3.gstatic.com/shopping?q=tbn:ANd9GcRoPxr8omhq2w52jcno8_na290YwMqXEUsSLPvhDr-9aItIhFRLYfjsk4fh2iGs6LATr-MAY68-F6vWIfXDuWHcwivicCp3ro8wcQGBXq4vtyj1CSScmoLl"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // --- Auto Slide Logic ---
  useEffect(() => {
    const slideInterval = setInterval(() => {
      nextSlide(); // Auto slide ke liye same function use kiya
    }, 5000); // Note: Maine time 2000ms (2 sec) kar diya hai taaki buttons click karna aasaan ho. 1 sec bohot fast hota hai.

    return () => clearInterval(slideInterval);
  }, [currentIndex]); // currentIndex add kiya taaki manual click ke baad timer reset ho jaye


  // --- Manual Navigation Functions ---
  
  const prevSlide = () => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? sliderImages.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const nextSlide = () => {
    const isLastSlide = currentIndex === sliderImages.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  return (
    <section className="relative w-full h-screen bg-gray-900 overflow-hidden group">
      
      {/* --- Slider Container --- */}
      <div 
        className="flex h-full w-full transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {sliderImages.map((imageUrl, index) => (
          <div key={index} className="relative w-full h-full flex-shrink-0">
            <img 
              src={imageUrl}
              alt={`Slide ${index + 1}`} 
              className="w-full h-full object-cover"
            />
            {/* Dark Overlay */}
            <div className="absolute inset-0 bg-black opacity-40"></div>
          </div>
        ))}
      </div>

      {/* --- Left Arrow Button --- */}
      <div onClick={prevSlide} className="absolute top-[50%] -translate-x-0 translate-y-[-50%] d-flex justify-center items-center left-5 text-2xl rounded-full p-3 px-6 border hover:border-blue-800 bg-black/20 text-white cursor-pointer hover:bg-blue-800 transition duration-300 z-20">
        {/* <ChevronLeft onClick={prevSlide} size={30} /> */}
        ◀ 
      </div>

      {/* --- Right Arrow Button --- */}
      <div onClick={nextSlide} className="absolute top-[50%] -translate-x-0 translate-y-[-50%] d-flex justify-center items-center right-5 text-2xl rounded-full p-3 px-6 border hover:border-blue-800 bg-black/20 text-white cursor-pointer hover:bg-blue-800 transition duration-300 z-20">
        {/* <ChevronRight onClick={nextSlide} size={30} /> */}
        ▶
      </div>

      {/* --- Optional: Dots Indicator (Bottom) --- */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
        {sliderImages.map((_, slideIndex) => (
          <div
            key={slideIndex}
            onClick={() => setCurrentIndex(slideIndex)}
            className={`cursor-pointer transition-all duration-300 rounded-full ${
              currentIndex === slideIndex ? "bg-blue-800 w-8 h-2" : "bg-white/50 w-2 h-2"
            }`}
          ></div>
        ))}
      </div>

      {/* --- Content Overlay --- */}
      <div className="absolute inset-0 z-10 flex flex-col justify-center items-center text-white pointer-events-none">
          {/* Text yahan aayega */}
      </div>
      
    </section>
  );
};

export default Hero;